import { setLoadingFalse, setLoadingTrue } from "../Config/Actions/loadingActions";
import instance from "./ApiConfig";
import { store } from "../Config/store";
export const baseApiCall = (config) => {
  store.dispatch(setLoadingTrue());
  return new Promise((resolve, reject) => {
    instance(config)
      .then((response) => {
        console.log('response Api', response);
         if (response?.status === 200) {
          resolve(response?.data);
          store.dispatch(setLoadingFalse());
        } 
      })
      .catch((e) => {
        console.log('api error', e);
        reject(e?.response?.data?.message);
      });
  });
};